import { useDeviceQueryApi } from "./useDeviceQueryApi";
export function useRegistersSubscription(names) {
  var queryApi = useDeviceQueryApi();
  return queryApi.useRegistersSubscription(names);
}